var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealthConsult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "#084F8A",
    strokeOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16H16C14.9 16 14 16.9 14 18V30C14 31.1 14.9 32 16 32H32C33.1 32 34 31.1 34 30V18C34 16.9 33.1 16 32 16ZM32 30H16V18H32V30ZM16 12H32V14H16V12ZM16 34H32V36H16V34ZM24 24C25.38 24 26.5 22.88 26.5 21.5C26.5 20.12 25.38 19 24 19C22.62 19 21.5 20.12 21.5 21.5C21.5 22.88 22.62 24 24 24ZM24 20.5C24.55 20.5 25 20.95 25 21.5C25 22.05 24.55 22.5 24 22.5C23.45 22.5 23 22.05 23 21.5C23 20.95 23.45 20.5 24 20.5ZM29 27.99C29 25.9 25.69 25 24 25C22.31 25 19 25.9 19 27.99V29H29V27.99ZM20.81 27.5C21.42 26.98 22.84 26.5 24 26.5C25.17 26.5 26.59 26.98 27.2 27.5H20.81Z",
    fill: "#027BCE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthConsult);
export default __webpack_public_path__ + "static/media/healthConsult.cacab7e8a6022d8fbfd095f5cf49b60f.svg";
export { ForwardRef as ReactComponent };